import { Action } from '@ngrx/store';
import { updateModelType } from './UpdateModelAction';
import { IAutoSaveAction } from './IAutoSaveAction';

export function updateModelErrorType<TParentModel, TModel>(module: string, parentType: { new(): TParentModel; }, type: { new(): TModel; } | string): string {
  return `${updateModelType(module, parentType, type)} Error`;
}

export function updateModelErrorTypeByAction(action: Action): string {
  return `${action.type} Error`;
}

export function updateModelErrorTypeByUpdateType(type: string): string {
  return `${type} Error`;
}

export class UpdateModelErrorAction<TParentModel, TModel> implements Action {
  readonly type: string;

  constructor(public payload: { action: IAutoSaveAction, errors: string[] }) {
    this.type = updateModelErrorTypeByAction(payload.action);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/workspace/store/actions/UpdateModelErrorAction.ts